// src/api/couponApi.js
import axios from 'axios';
import config from './config';

const API_URL = `${config.API_BASE_URL}/Coupons`;

// ==================== CRUD ====================

export const fetchCoupons = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.type) queryParams.append('type', params.type);
    if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);
    if (params.branchId) queryParams.append('branchId', params.branchId);
    
    const queryString = queryParams.toString();
    const url = queryString ? `${API_URL}?${queryString}` : API_URL;
    
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching coupons:', error);
    throw error;
  }
};

export const fetchCouponById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching coupon:', error);
    throw error;
  }
};

export const createCoupon = async (couponData) => {
  try {
    const response = await axios.post(API_URL, couponData);
    return response.data;
  } catch (error) {
    console.error('Error creating coupon:', error);
    throw error;
  }
};

export const updateCoupon = async (id, couponData) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, couponData);
    return response.data;
  } catch (error) {
    console.error('Error updating coupon:', error);
    throw error;
  }
};

export const deleteCoupon = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting coupon:', error);
    throw error;
  }
};

// ==================== SPECIAL ENDPOINTS ====================

export const validateCoupon = async (validationData) => {
  try {
    const response = await axios.post(`${API_URL}/validate`, validationData);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      return error.response.data;
    }
    throw error;
  }
};

export const fetchCouponsForBranch = async (branchId) => {
  try {
    const response = await axios.get(`${API_URL}/branch/${branchId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching coupons for branch:', error);
    throw error;
  }
};

export const toggleCouponActive = async (id) => {
  try {
    const response = await axios.patch(`${API_URL}/${id}/toggle`);
    return response.data;
  } catch (error) {
    console.error('Error toggling coupon:', error);
    throw error;
  }
};

export const fetchCouponStats = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/${id}/stats`);
    return response.data;
  } catch (error) {
    console.error('Error fetching coupon stats:', error);
    throw error;
  }
};